function getLogApiUrl() {
    const env = import.meta.env.VITE_TRANSLATE_API_URL;
    if (env && env.startsWith('http')) return env.replace(/\/translate\/?$/, '') + '/log';
    if (typeof window !== 'undefined' && window.location.origin && !window.location.origin.includes('localhost'))
        return window.location.origin + '/log';
    return 'http://localhost:5002/log';
}

const LOG_API_URL = getLogApiUrl();

function serverLog(level, message, data) {
    const payload = data !== undefined ? [message, data] : [message];
    if (level === 'error') console.error(...payload);
    else if (level === 'warn') console.warn(...payload);
    else console.log(...payload);
    fetch(LOG_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ level, message, data })
    }).catch(() => {});
}

export function log(message, data) {
    serverLog('log', message, data);
}
export function warn(message, data) {
    serverLog('warn', message, data);
}
export function error(message, data) {
    serverLog('error', message, data);
}
